import type { StackProps } from '@mui/material'

import type { LocationEditorProps } from '../types.js'

export function useRootProps(props: LocationEditorProps) {
  const { testId = 'LocationEditor', className = '', sx, slotProps } = props

  const rootProps: StackProps = {
    ...slotProps?.root,
    className,
    // @ts-expect-error
    'data-testid': testId,
    sx,
  }

  return rootProps
}
